const UMAMI_HOST = import.meta.env.VITE_UMAMI_HOST;
const UMAMI_WEBSITE_ID = import.meta.env.VITE_UMAMI_WEBSITE_ID;

if (UMAMI_HOST && UMAMI_WEBSITE_ID) {
  const script = document.createElement("script");
  script.defer = true;
  script.src = `${UMAMI_HOST}/script.js`;
  script.dataset.websiteId = UMAMI_WEBSITE_ID;
  document.head.appendChild(script);
}
